module.exports = __webpack_public_path__ + "img/tb-6.e22dff3f.png";